import { setPassword, updateHandle, updatePassword } from '../../api/memberApi';
import { SimpleStringResponse } from '../../dto/ResDtoRepository';
import { useApiWrapper } from './apiWrapper';
import { SetPasswordReq, UpdateHandleReq, UpdatePasswordReq } from '../../dto/ReqDtoRepository';
import { usePageOwnerIdentityStore } from '../../store/pageOwnerIdentityStore';
import { useTempAlertStore } from '../../store/portal/tempAlertStore';
import { useModalStore } from '../../store/portal/modalStore';
import { useAuthStore } from '../../store/authStore';
import { PasswordStatus } from '../../enum/EnumRepository';
import { useAuth } from './useAuth';
import { runCurrentArchiveRequest } from '../../util/currentArchiveRequest';


interface UseMemberResult {
  updateHandle: (data: UpdateHandleReq) => Promise<void>;
  updatePassword: (data: UpdatePasswordReq) => Promise<void>;
  setPassword: (data: SetPasswordReq) => Promise<void>;
}

export const useMember = (): UseMemberResult => {
  const { user, setUser } = useAuth();
  const { pageOwner } = usePageOwnerIdentityStore();
  const { clearModal } = useModalStore();
  const { setPasswordStatus } = useAuthStore.getState();
  const { setUpdatedTempAlert } = useTempAlertStore();
  const withApiHandler = useApiWrapper();


  const handleUpdateHandleSuccess = (response: SimpleStringResponse) => {
    const data = response.data;
    const newHandle = data.value;
    if (!user) return;
    if (!newHandle) return;
    setUser({ ...user, handle: newHandle });
    //이러면 전부 다 날라가서 pageOwner 갱신 프로세스 탐
    window.location.href = `/@${newHandle}/settings`;
  };

  const handleUpdatePasswordSuccess = () => {
    clearModal();
    setUpdatedTempAlert();
  };

  const handleSetPasswordSuccess = () => {
    clearModal();
    setPasswordStatus(PasswordStatus.OK);
    setUpdatedTempAlert();
  };

  const handleMemberRequest = async (
    action: 'password' | 'set_password' | 'update_handle',
    data?: UpdatePasswordReq | SetPasswordReq | UpdateHandleReq
  ) => {
    if (!pageOwner) return;
    const { aui } = pageOwner;
    const apiFunction = async () => {
      switch (action) {
        case 'update_handle': {
          return runCurrentArchiveRequest(
            aui,
            () => updateHandle(aui, data as UpdateHandleReq),
            handleUpdateHandleSuccess,
          );
        }
        case 'password': {
          return runCurrentArchiveRequest(
            aui,
            () => updatePassword(aui, data as UpdatePasswordReq),
            handleUpdatePasswordSuccess,
          );
        }
        case 'set_password': {
          return runCurrentArchiveRequest(
            aui,
            () => setPassword(aui, data as SetPasswordReq),
            handleSetPasswordSuccess,
          );
        }
        default:
          return;
      }
    };
    await withApiHandler(apiFunction, [aui, action, data]);
  };

  const updatePasswordHandler = (data: UpdatePasswordReq) => handleMemberRequest('password', data);
  const updateHandleHandler = (data: UpdateHandleReq) => handleMemberRequest('update_handle', data);
  const setPasswordHandler = (data: SetPasswordReq) => handleMemberRequest('set_password', data);

  return {
    updateHandle: updateHandleHandler,
    updatePassword: updatePasswordHandler,
    setPassword: setPasswordHandler,
  };
}
